// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","headerHeightXs":"75px","headerHeightSm":"91px","headerHeightMd":"132px"};